module.exports = __webpack_public_path__ + "static/media/style3.b048ebea.svg";